import homenowGreenLogo from '../../img/homenow-green.png'
import roofnowPlaceholderLogo from '../../img/roofnow-placeholder.png'

/**
 * Logo files of the cover-only brands (`COVER_ONLY_COMPANIES`, common/), by
 * short name. Imported as files, never base64 (B165).
 *
 * HOMENOW uses the green logo, same as the app icon and login (Luis Oct 30).
 */
// TODO(Jaron): replace with real ROOFNOW logo (this is a generated placeholder).
export const COVER_ONLY_LOGOS: Readonly<Record<string, string>> = {
  HOMENOW: homenowGreenLogo,
  ROOFNOW: roofnowPlaceholderLogo,
}
